import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "nexus_cookie_consent";
const EVT = "nexus:cookie-preferences";

export const openCookiePreferences = () => window.dispatchEvent(new Event(EVT));

export const getCookieConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
};

export const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(!getCookieConsent()), 1200);
    const reopen = () => setOpen(true);
    window.addEventListener(EVT, reopen);
    return () => {
      clearTimeout(t);
      window.removeEventListener(EVT, reopen);
    };
  }, []);

  const save = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, date: new Date().toISOString() }));
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          role="dialog"
          aria-label="Avviso cookie"
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-[60] rounded-2xl border border-navy/10 bg-white p-5 shadow-[0_20px_60px_rgba(24,49,79,0.18)] sm:inset-x-auto sm:bottom-6 sm:left-6 sm:max-w-md sm:p-6"
        >
          <div className="flex items-start gap-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-mist">
              <Cookie className="h-5 w-5 text-gold-ink" strokeWidth={1.5} />
            </span>
            <div>
              <p className="text-sm font-semibold text-navy">Il rispetto della tua privacy</p>
              <p className="mt-2 text-[13px] leading-relaxed text-slate2">
                Usiamo cookie tecnici necessari al funzionamento del sito. Eventuali cookie facoltativi verranno usati solo con il tuo consenso.{" "}
                <Link to="/cookie-policy" className="font-semibold text-navy underline underline-offset-2" data-testid="cookie-banner-policy-link">Cookie Policy</Link>
              </p>
            </div>
          </div>
          <div className="mt-5 grid grid-cols-2 gap-3">
            <button type="button" onClick={() => save("rejected")} data-testid="cookie-reject-btn" className="rounded-full border border-navy/25 px-4 py-2.5 text-sm font-semibold text-navy transition-colors hover:border-navy">
              Rifiuta
            </button>
            <button type="button" onClick={() => save("accepted")} data-testid="cookie-accept-btn" className="rounded-full bg-navy px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-navy-deep">
              Accetta
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
